import PropTypes from 'prop-types';
var containerPropType = PropTypes.oneOfType([PropTypes.func, typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)]);
export default containerPropType;